// @flow

import { graphql } from 'react-relay';
import { ROOT_ID } from 'relay-runtime';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation DeleteInvoiceMutation($input: DeleteInvoiceInput!) {
    deleteInvoice(input: $input) {
      deletedId
    }
  }
`;

export default {
  commit: (options: Object) => {
    return createRelayMutation(mutation, {
      ...options,
      configs: [
        {
          type: 'RANGE_DELETE',
          parentID: ROOT_ID,
          connectionKeys: [{ key: 'PaginatedInvoicesContainer_invoices' }],
          pathToConnection: [ROOT_ID, 'invoices'],
          deletedIDFieldName: 'deletedId',
        },
      ],
    });
  },
};
